import CPWhereView from 'text!../views/cp-where.html';
import CPWhereCtrl from 'edge/fnol/cp/controllers/CPWhereCtrl';
import CPRiskUnitsView from 'text!../views/cp-risk-units.html';
import CPRiskUnitsCtrl from 'edge/fnol/cp/controllers/CPRiskUnitsCtrl';
import CPWhatView from 'text!../views/cp-what.html';
import CPWhatCtrl from 'edge/fnol/cp/controllers/CPWhatCtrl';
import CPPropertyDetailsView from 'text!../views/cp-property-details.html';
import CPPropertyDetailsCtrl from 'edge/fnol/cp/controllers/CPPropertyDetailsCtrl';
import CPBaseFnolWizardCtrl from 'edge/fnol/cp/controllers/CPBaseFnolWizardCtrl';

export default function () {
    const cpBaseFnolWizard = {
        name: 'cpBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: CPBaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    return {
        cpBaseFnolWizard: cpBaseFnolWizard,
        cpWhat: {
            name: 'cpWhat',
            parent: cpBaseFnolWizard,
            template: CPWhatView,
            controller: CPWhatCtrl
        },
        cpRiskUnits: {
            name: 'cpRiskUnits',
            parent: cpBaseFnolWizard,
            template: CPRiskUnitsView,
            controller: CPRiskUnitsCtrl
        },
        cpPropertyDetails: {
            name: 'cpPropertyDetails',
            parent: cpBaseFnolWizard,
            template: CPPropertyDetailsView,
            controller: CPPropertyDetailsCtrl
        },
        cpWhere: {
            name: 'cpWhere',
            parent: cpBaseFnolWizard,
            template: CPWhereView,
            controller: CPWhereCtrl
        }
    };
}
